import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { useGetContactInfo } from "@features/ux/components/recipientList/hooks";
import { Tooltip, TooltipContent, TooltipTrigger } from "@shared/ui/tooltip";
import {
  CircleX,
  HelpCircle,
  Mail,
  Phone,
  Smartphone,
  Users,
} from "lucide-react";
import React from "react";
import { useParams } from "react-router-dom";

const UsageHistoryDashboard = () => {
  const { id } = useParams();
  const {data: contactInfo } = useGetContactInfo(Number(id))
  const statsData = [
    {
      title: "Total",
      count: contactInfo?.total || 0,
      icon: <Users className="h-8 w-8 text-blue-500" />,
    },
    {
      title: "Email Only",
      count: contactInfo?.emailOnly || 0,
      icon: <Mail className="h-8 w-8 text-green-500" />,
    },
    {
      title: "Phone Only",
      count: contactInfo?.phoneOnly || 0,
      icon: <Phone className="h-8 w-8 text-orange-500" />,
    },
    {
      title: "Both",
      count: contactInfo?.bothAvailable || 0,
      icon: <Smartphone className="h-8 w-8 text-blue-500" />,
    },
    {
      title: "No Contact",
      count: contactInfo?.noContact || 0,
      icon: <CircleX className="h-8 w-8 text-orange-500" />,
    },
  ];
  return (
    <div>
      <div className="flex item-center gap-2">
        <div>
          <h2 className="text-sm font-bold">Contact Information Overview</h2>
        </div>
        <div>
          <Tooltip>
            <TooltipTrigger>
              <HelpCircle className="h-4 w-4 text-gray-400" />
            </TooltipTrigger>
            <TooltipContent>
              <p className="max-w-xs">
                Breakdown of available contact methods for recipients in this list
              </p>
            </TooltipContent>
          </Tooltip>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mt-4">
        {statsData.map((stat, index) => (
          <QuickStatsCard
            key={index}
            title={stat.title}
            count={stat.count}
            icon={stat.icon}
          />
        ))}
      </div>
    </div>
  );
};

export default UsageHistoryDashboard;
